import { useState, useEffect } from "react";
import AddStore from "../components/AddStore";
import axios from "axios";
import StoreDetails from "../components/StoreDetails";

export default function ManageStores(params) {
  const [selectedStore, setSelectedStore] = useState(null);
  const [storesData, setStoresData] = useState([]);
  useEffect(() => {
    fetchStores();
  }, []);

  const fetchStores = async () => {
    try {
      const res = await axios.get(
        "https://buttery-substantial-helicopter.glitch.me/stores"
      );
      setStoresData(res.data);
      // console.log(res.data);
    } catch (error) {
      console.log("ERROR", error);
    }
  };
  const handleStoreClick = (store) => {
    setSelectedStore(store);
  };

  return (
    <div className="w-full px-4 py-5 my-3 bg-white rounded-lg shadow">
      <div className="flex justify-between align-middle">
        <h2 className=" text-gray-800 font-semibold truncate">Manage Stores</h2>

        <AddStore fetchStores={fetchStores} />
      </div>
      <div className="">
        {storesData.map((store) => (
          <div
            key={store._id}
            className="flex flex-col rounded-lg bg-white shadow-lg w-full my-4 cursor-pointer md:flex-row"
            onClick={() => handleStoreClick(store)}
          >
            <div className="flex flex-col justify-start p-6">
              <h5 className="mb-2 text-3xl font-bold text-neutral-800">
                {store.name}
              </h5>
              <p className="mb-4 text-base text-neutral-600 ">
                {store.address}
              </p>

              {/* <span className="text-2xl font-semibold inline-block text-teal-500">
                Cost {store.cost}
              </span>
              <span className="text-2xl font-semibold inline-block text-teal-500">
                Sell {store.sell}
              </span> */}
            </div>
          </div>
        ))}
        {selectedStore && (
          <StoreDetails
            store={selectedStore}
            closeModal={() => setSelectedStore(null)}
          />
        )}
      </div>
    </div>
  );
}
